module.exports = __webpack_public_path__ + "img/close-icon.a85c4975.svg";